<div class="Modal">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <p>Política de privacidade</p>
    </div>
    <span class="material-icons float-end CloseModal" (click)="closeModal()">
      close
    </span>
  </div>
  <div class="ModalContent">
    <!-- <div *ngIf="!policity.pdf" class="loader"><img width="30px" src="/assets/svg/icon-spinner.svg"></div>
      <pdf-viewer *ngIf="policity.pdf" [src]="policity.pdf"  style="width:  100%; height: 500px" [original-size]="false" [show-all]="true" [autoresize]="true" [fit-to-page]="true"  ></pdf-viewer> -->
    <div class="container text-center">
      <div class="row mb-4">
        <div class="col text-center mt-4">
          <button
            mat-button
            class="Btn BtnPadrao"
            (click)="policity.download()"
            [disabled]="!policity.pdf"
          >
            <span class="material-icons"> download </span>
            Baixar versão em PDF
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <div class="mb-4">
            <a
              href="https://www.sabemi.com.br/politica-de-privacidade"
              target="_blank"
              class="text-underline"
            >
              Acessar versão on-line
              <span class="material-icons align-middle me-10"
                >arrow_outward</span
              >
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
